import React, { FC, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

type AuthSwitchWrapperProps = {
  children: React.ReactNode;
};

const AuthPage = lazy(
  () =>
    import(
      /* webpackChunkName: "authPage", webpackPrefetch: true */
      'pages/AuthPage'
    ),
);

export const AuthSwitchWrapper: FC<AuthSwitchWrapperProps> = ({ children }) => {
  if (__USE_AUTH_TYPE__ === 'SESSION') {
    return (
      <Switch>
        <Route path='/auth'>
          <Suspense fallback={<div>Error</div>}>
            <AuthPage />
          </Suspense>
        </Route>
        <>{children}</>
      </Switch>
    );
  }

  return <>{children}</>;
};
